import { AttributesMixin, define, Model, type } from "@type-r/models";
import { restfulIO } from "api/endpoint";

const rootCustomerProfile = '/api/v2/invoice-management/Landing/customer-profile';

@define
export class NewRelationshipGroup extends Model {
    static attributes = {
        relationshipId: Number,
        customerName: String,
        customerExternalId: String,
        count: Number,
        outstandingAmountSum: Number,
        hasCustomer: Boolean
    };
}
export interface NewRelationshipGroup extends AttributesMixin<typeof NewRelationshipGroup> { }

@define
export class CustomerProfileLandingSummary extends Model {
    static endpoint = restfulIO(`${rootCustomerProfile}/`);

    static attributes = {
        newRelationships: type([NewRelationshipGroup]).dontSave.endpoint(restfulIO("./open-items/new-relationships")),
        isTodoReady: Boolean,
        isReviewReady: Boolean
    }

    async fetch(options?: {}) {
        await Promise.all([
            this.newRelationships.fetch(),
        ]).then(() => this.isTodoReady = true)
            .catch(e => {
                console.log('fetch error CustomerProfileLandingSummary');
                console.log(e);
                this.isTodoReady = true;
            });

        return this;
    }

    get todoCount() {
        return this.totalNewRelationships;
    }

    get totalNewRelationships() {
        return this.newRelationships.length;
    }

    get reviewCount() {
        return 0;
    }
}
export interface CustomerProfileLandingSummary extends AttributesMixin<typeof CustomerProfileLandingSummary> { }